<template>
  <div class="adminCommandesGestion">
    <div class="adminCommandesForm">
      <div class="adminCommandesFormLine">
        <div class="flex-fJstart-fAcenter">
          <span>Référence commande exacte :</span>
          <input
            type="reference"
            v-model="reference"
          >
          <input
            v-if="reference!==null && reference!==''"
            type="button"
            class="ui-icon ui-icon-closethick"
            @click="reference = null"
          >
        </div>
      </div>
      <div class="adminCommandesFormLine flex-wrap-fJstart-fAcenter">
        <div class="flex-fJstart-fAcenter">
          <span>Client :</span>
          <vue-select
            :options="clientsArray"
            v-model="codeClient"
            label="libelle"
            :reduce="entry => entry.code"
          >
            <span slot="no-options">Aucun client correspondant à votre recherche</span>
          </vue-select>
        </div>
        <div class="flex-fJstart-fAcenter">
          <span>Entre le :</span>
          <input
            type="date"
            v-model="dateDebut"
          >
          <span>Et le :</span>
          <input
            type="date"
            v-model="dateFin"
          >
        </div>
        <div
          class="flex-fJstart-fAcenter"
          v-if="agencesOptions.length > 1"
        >
          <span>Agence :</span>
          <vue-select
            :options="agencesOptions"
            v-model="codeAgence"
            label="libelle_agence"
            :reduce="entry => entry.code_agence"
          >
            <span slot="no-options">Aucune agence correspondante à votre recherche</span>
          </vue-select>
        </div>
        <button
          @click="rechercher"
          :disabled="fetchingCommandes"
        >
          Rechercher
        </button>
      </div>
    </div>

    <div
      v-if="messageCommande !== null"
      class="adminCommandesAlert"
    >
      {{ messageCommande }}
    </div>

    <div>
      <table>
        <thead>
          <tr>
            <th>
              Date
            </th>
            <th>
              Id OEC
            </th>
            <th>
              Référence commande <br> Numéro de bon
            </th>
            <th v-if="agencesOptions.length > 1">
              Agence
            </th>
            <th>
              Client<br>Type de client
            </th>
            <th>
              Montants
            </th>
            <th>
              Type de paiement <br> Statut du paiement
            </th>
            <th>
              Statut de la commande
            </th>
            <th
              v-if="afficherActions === '1'"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="fetchingCommandes">
            <td colspan="5">Recherche en cours ...</td>
          </tr>
          <tr v-else-if="commandes.total === 0">
            <td colspan="5">Aucune donnée à afficher</td>
          </tr>
          <tr
            v-else
            v-for="commande of commandes.elements"
            :key="commande.id"
            :set="client = clients[commande.codeClient]"
            class="adminCommandesLigne"
          >
            <td>
              <span>{{ displayDate(commande.date) }}</span>
            </td>
            <td>
              <span>{{ commande.webCdeId }}</span>
            </td>
            <td>
              <span>Réf. {{ commande.refClient }}</span>
              <br>
              <span v-if="commande.typeWebMouvement !== 'web'">N° {{ commande.numero }}</span>
            </td>
            <td v-if="agencesOptions.length > 1">
              <span :title="agencesArray[commande.codeAgence]">{{ commande.codeAgence }}</span>
            </td>
            <td v-if="client===undefined">
              <span>{{ commande.codeClient }}</span>
            </td>
            <td v-else>
              <span>{{ client.libelle }}</span>
              <br>
              <span>{{ client.libelle_type }} ({{ client.code_type }})</span>
            </td>
            <td class="montant">
              <span v-if="commande.montantHT !== null">{{ displayMontant(commande.montantHT) }} HT</span>
              <br>
              <span v-if="commande.montantTTC !== null">{{ displayMontant(commande.montantTTC) }} TTC</span>
            </td>
            <td>
              <span>{{ commande.libelleModeReglement }}</span>
              <br>
              <span v-if="commande.typePanier !== null">{{ statutReglementLibelles[commande.typePanier] }}</span>
            </td>
            <td>
              <span v-if="commande.etat !== null">{{ statutLibelles[commande.typeWebMouvement] }}{{ statutLibelles[commande.etat] }}</span>
              <span v-else>{{ statutLibelles[commande.typeWebMouvement] }}</span>
            </td>
            <td
              v-if="afficherActions === '1'"
              class="adminCommandesActions"
            >
              <div class="flex-fJstart-fAcenter">
                <button
                  type="button"
                  class="pixel_32 icon-eye"
                  title="Afficher la commande"
                  @click="goToDetail(commande.id, commande.codeClient, commande.typeWebMouvement)"
                />
                <button
                  v-if="commande.typeWebMouvement === 'web'"
                  type="button"
                  class="pixel_32 icon-arrow-share-square-o"
                  title="Re-exporter cette commande"
                  @click="goRenvoyerCommande(commande.webCdeId, $event)"
                />
                <form
                  v-if="commande.typeWebMouvement === 'web'"
                  name="formEditeCommande"
                  action="/openweb/admin/admin_commandeEdite"
                  method="POST"
                >
                  <input
                    type="hidden"
                    name="id"
                    :value="commande.webCdeId"
                  >
                  <input
                    type="hidden"
                    name="action"
                    value="EXPORT"
                  >
                  <input
                    type="hidden"
                    name="valide"
                    value="1"
                  >
                  <button
                    type="submit"
                    name="download"
                    class="pixel_32 icon-cloud-download"
                    title="Télécharger le fichier intégrable"
                  />
                </form>
                <button
                  v-if="commande.typePanier === 'ATT' || commande.typePanier === 'AT2'"
                  type="button"
                  class="pixel_32 icon-check-square-o"
                  title="Accéder à la validation du paiement"
                  @click="goValiderPaiement(commande.numero, $event)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        v-if="commandes.total !== 0"
        :current="currentPage"
        :pages="pagesNumber"
        @change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Pagination from './Pagination'
import VueSelect from 'vue-select'

export default {
  components: { Pagination, VueSelect },
  props: {
    afficherActions: {
      type: String,
      default: '0'
    }
  },
  data: function() {
    return {
      pageSize: 20,
      currentPage: 1,
      statutLibelles: {
        web: 'Commande validée web',
        cde: 'Commande',
        E_PRE: ' préparée',
        E_DIS: ' en cours de préparation',
        E_LIV: ' livrée',
        E_FAC: ' facturée',
        E_LIVPAR: ' partiellement livrée',
        E_CDEFOU: ' en cours de réapprovisionnement'
      },
      statutReglementLibelles: {
        TER: 'Commande terminée',
        VAL: 'Paiement validé',
        ATT: 'Paiement non validé par la banque',
        AT2: 'En attente de validation du règlement'
      },
      dateDebut: null,
      dateFin: null,
      codeClient: null,
      codeAgence: null,
      reference: null
    }
  },
  async created() {
    await this.getClients()
    await this.getAgences()
    this.changePage(1)
  },
  computed: {
    ...mapGetters([
      'commandes',
      'clients',
      'fetchingCommandes',
      'messageCommande',
      'agencesOptions'
    ]),
    pagesNumber: function() {
      return Math.ceil(this.commandes.total / this.pageSize)
    },
    clientsArray: function() {
      return Object.keys(this.clients).map((key) => this.clients[key])
    },
    agencesArray: function() {
      let agences = []
      for (let index in this.agencesOptions) {
        let option = this.agencesOptions[index]
        agences[option.code_agence] = option.libelle_agence
      }
      return agences
    }
  },
  methods: {
    ...mapActions([
      'updateCommandes',
      'getClients',
      'renvoyerCommande',
      'getAgences'
    ]),
    changePage: function(page) {
      this.currentPage = page
      this.updateCommandes({ page: page-1, size: this.pageSize, dateDebut: this.dateDebut, dateFin: this.dateFin, codeClient: this.codeClient, codeAgence: this.codeAgence, reference: this.reference })
    },
    rechercher: function() {
      this.changePage(1)
    },
    goToDetail: function(id, codeClient, type) {
      if (type === 'web')
        window.open('/compte/detail-mouvement/' + id + '/web?codeClient=' + codeClient, '_blank')
      else
        window.open('/compte/detail-mouvement?numMouvement=' + id + '&typeMouvement=cde&codeClient=' + codeClient, '_blank')
    },
    displayDate: function(timestamp) {
      let date = new Date(timestamp * 1000)
      if (date.getHours() === 0 && date.getMinutes() === 0)
        return date.toLocaleString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        })
      else
        return date.toLocaleString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
    },
    displayMontant: function (montant) {
      return parseFloat(montant).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })
    },
    goRenvoyerCommande: function(id, event) {
      if ( confirm( 'Etes-vous sûr(e) de vouloir renvoyer cette commande ?' ) ) {
        this.renvoyerCommande(id)
      }
      event.stopPropagation()
    },
    goValiderPaiement: function(id, event) {
      window.open('/openweb/admin/admin_commandeValideReglement?id=' + id, '_blank')
    }
  }
}
</script>

<style scoped>
.montant span {
  white-space: nowrap;
}
</style>
